import PropTypes from 'prop-types';
import React from 'react';
import shortid from 'shortid';
import ToolTip from '../../../Elements/ToolTip/ToolTip';
import SubmitComment from '../SubmitComment/SubmitComment';
import './RowRecord.scss';

export default class RowRecord extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = this.getInitState();
    }

    getInitState() {
        return {
            tip: this.props.tipInputType === 'dropdown' ? 1 : '',
            comment: '',
        };
    }

    onTipChange = (tip) => {
        this.setState({ tip });
    };

    onCommentChange = (comment) => {
        this.setState({ comment });
    };

    clearForm = () => {
        this.setState(this.getInitState());
    };

    onSubmit = () => {
        if (!this.state.tip || this.state.tip.length <= 0) {
            this.props.onCommentSubmit(
                this.props.type,
                null,
                this.state.comment
            );
        } else {
            this.props.onCommentSubmit(
                this.props.type,
                this.state.tip,
                this.state.comment
            );
        }
    };

    renderMedian = () => {
        if (this.props.description) {
            return (
                <div>
                    <span className="d-inline d-md-none font-italic black">
                        Median/Consensus: &nbsp;
                    </span>
                    <span
                        className="purple"
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={(e) => {
                            this.tooltip.show(e);
                        }}
                        onTouchStart={(e) => {
                            this.tooltip.show(e);
                        }}
                        onMouseLeave={(e) => {
                            this.tooltip.hide(e);
                        }}
                    >
                        {this.props.median}
                        <ToolTip
                            ref={(node) => {
                                this.tooltip = node;
                            }}
                            type=""
                            direction="up"
                        >
                            <span className="black">
                                {this.props.description}
                            </span>
                        </ToolTip>
                    </span>
                </div>
            );
        }
        return (
            <div>
                <span>{this.props.median}</span>
            </div>
        );
    };

    render() {
        return (
            <div className="component-Employer-Benefits-RowRecord">
                <div className="row no-gutters">
                    <div className="left-col">
                        <div className="row darker-row no-gutters p-3">
                            <div className="col-12  col-md-6">
                                <div className="field-name">
                                    {this.props.fieldName}
                                </div>
                            </div>
                            <div className="col-2 d-none d-md-block record">
                                <div className="text-center black">
                                    {this.props.low}
                                </div>
                            </div>
                            <div className="col-12 col-md-2">
                                <div className="text-left text-md-center record">
                                    {this.renderMedian()}
                                </div>
                            </div>
                            <div className="col-2 d-none d-md-block record">
                                <div className="text-center black">
                                    {this.props.high}
                                </div>
                            </div>
                        </div>

                        <div className="comments pt-2 pb-2">
                            <ul className="pr-3">
                                {this.props.comments
                                    .filter((e) => !!e)
                                    .map((comment) => (
                                        <li key={shortid.generate()}>
                                            {comment}
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>

                    <div className="right-col">
                        <SubmitComment
                            type={this.props.type}
                            title={this.props.fieldName}
                            tip={this.state.tip}
                            comment={this.state.comment}
                            onTipChange={this.onTipChange}
                            onCommentChange={this.onCommentChange}
                            onSubmit={this.onSubmit}
                            clearForm={this.clearForm}
                            tipInputType={this.props.tipInputType}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RowRecord.propTypes = {
    /**
     * label of the record
     */
    fieldName: PropTypes.string.isRequired,
    /**
     * lowest record
     */
    low: PropTypes.string,
    /**
     * highest record
     */
    high: PropTypes.string,
    /**
     * median record
     */
    median: PropTypes.string,
    /**
     * array of comments
     */
    comments: PropTypes.arrayOf(PropTypes.string),
    /**
     * type of policy
     */
    type: PropTypes.string.isRequired,
    /**
     * function for submitting comments/tips
     */
    onCommentSubmit: PropTypes.func.isRequired,
    /**
     * description of the data, to be displayed on tooltip
     */
    description: PropTypes.string,
    /**
     * tip input type
     */
    tipInputType: PropTypes.oneOf(['dropdown', 'inputBox']),
};

RowRecord.defaultProps = {
    low: '',
    high: '',
    median: '?',
    comments: [],
    description: null,
    tipInputType: 'inputBox',
};
